import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, FormGroup, ControlLabel } from 'react-bootstrap';
import { pickBy } from 'lodash';
import PropTypes from 'prop-types';

import Spinner from '../../../../../components/Loaders/Spinner';
import Alert from '../../../../../components/Alert';
import Dropdown from '../../../../../components/Dropdown/Default';

const AddEditModal = ({ access, error, open, type, item, available, isLoading, isLoadingSubmit, onSubmit, onDelete, onHide }) => {
  const [form, setForm] = useState({
    field: null,
    required: false,
  });

  const fieldOptions = useMemo(() => {
    if (type === 'edit') {
      return [item, ...available?.map((opt) => ({ ...opt, id: opt.default_id }))];
    }
    return available?.map((opt) => ({ ...opt, id: opt.default_id }));
  }, [type, available, item]);

  const handleSelect = (field, key) => {
    switch (field) {
    case 'field':
      const find = fieldOptions?.find((f) => f.code === key);
      setForm((prevState) => ({ ...prevState, field: find }));
      break;

    case 'required':
      setForm((prevState) => ({ ...prevState, required: key === 1 ? { id: 1, title: 'No' } : { id: 2, title: 'Yes' } }));
      break;

    default:
      break;
    }
  };

  const onSubmitForm = (event) => {
    event?.preventDefault();
    const prepareForm = type === 'add'
      ? { field: form.field?.default_id, required: form.required?.id !== 1 }
      : pickBy(
        { field: item?.id, required: form.required?.id !== 1, new_code: form.field?.code !== item?.code ? form.field?.code : null },
        (value) => value !== undefined && value !== null,
      );
    onSubmit?.(type, prepareForm);
  };

  useEffect(() => {
    if (type === 'add') {
      setForm({
        field: available?.[0],
        required: { id: 1, title: 'No' },
      });
    }
    if (type === 'edit') {
      setForm({
        field: item,
        required: item?.required ? { id: 2, title: 'Yes' } : { id: 1, title: 'No' },
      });
    }
  }, [type, item, available]);

  return (
    <Modal show={open} onHide={onHide} backdrop="static" className="modal-md-custom signup-modal">
      <Modal.Header closeButton>
        <Modal.Title>{type === 'add' ? 'Add field' : 'Edit field'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert text={error} />}
        {isLoading ? (
          <div className="modal-loader-small" />
        ) : (
          <>
            <FormGroup>
              <ControlLabel>Field</ControlLabel>
              <Dropdown title={form.field?.title} items={fieldOptions} handleSelect={(key, item) => handleSelect('field', key, item)} simple />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Required</ControlLabel>
              <Dropdown
                title={form.required?.title}
                handleSelect={(key, item) => handleSelect('required', key, item)}
                items={[
                  { id: 1, title: 'No' },
                  { id: 2, title: 'Yes' },
                ]}
                simple
              />
            </FormGroup>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit || isLoading} onClick={onSubmitForm}>
          {isLoadingSubmit && <Spinner />}
          <span>{type === 'add' ? 'Add field' : 'Save'}</span>
        </Button>
        <Button
          onClick={() => {
            onHide();
          }}
        >
          Cancel
        </Button>
        {type === 'edit' && access?.signup_delete ? (
          <div className="pull-right" style={{ position: 'relative' }}>
            <Button bsStyle="link" className="modal-delete-btn" onClick={onDelete}>
              <span>Delete</span>
            </Button>
          </div>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};

AddEditModal.propTypes = {
  access: PropTypes.object,
  error: PropTypes.string,
  open: PropTypes.bool,
  type: PropTypes.string,
  item: PropTypes.object,
  available: PropTypes.array,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onDelete: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddEditModal;
